import { useAuth0 } from "@auth0/auth0-react"
import { VisibilityOff, Visibility } from "@mui/icons-material"
import { LoadingButton } from "@mui/lab"
import { Typography, Box, TextField, InputAdornment, IconButton, Button, Checkbox, FormControlLabel } from "@mui/material"
import { useState } from "react"
import { NavLink } from "react-router-dom"
import { useContent } from "../../logic"
import termsOfUse from '../../../assets/termsOfUse.pdf'
import { useOrganization } from "../OrganizationProvider"

export function UnauthedFormComponent({ onSubmit, loading, pinIsCorrect, text }: {
  onSubmit: (pin: string) => void
  loading: boolean
  pinIsCorrect: boolean
  text: string
}) {

  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
  }

  const { userAcceptedTerms } = useOrganization()

  const { ClosingsText } = useContent()
  const { isAuthenticated } = useAuth0();
  const [showPassword, setShowPassword] = useState(false)
  const [pin, setPin] = useState<string | null>(null)
  const [termsChecked, setTermsChecked] = useState(Boolean(userAcceptedTerms))

  return (
    !pinIsCorrect ? <>
      <Typography sx={{
        fontSize: 26,
        fontWeight: 300,
        lineHeight: '36px',
        letterSpacing: '-0.5px',
        mb: 2, ml: 4,
        alignSelf: 'start'
      }}>
        Please enter your pin
      </Typography>
      <Box sx={{
        width: '90%', maxWidth: '500px',
        alignSelf: 'center',
      }}>
        <form
          onSubmit={(e) => {
            e.preventDefault()
            const formData = new FormData(e.currentTarget);
            const localPin = formData.get('pin') as string | null
            if (!localPin) {
              return
            }
            setPin(localPin)
            onSubmit(localPin)
          }}
        >
          <TextField
            name="pin"
            required
            id="outlined-required"
            label="Pin"
            sx={{ width: '100%' }}
            autoComplete="pin"
            type={showPassword ? 'text' : 'password'}
            InputProps={{
              autoFocus: true,
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => setShowPassword((show) => !show)}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              )
            }}
          />
          <Typography sx={{
            fontSize: 'smaller',
            fontWeight: 400,
            lineHeight: '20px',
            letterSpacing: '0.1px',
            mt: 1, ml: 1,
          }}>
            Your pin will have accompanied the link to this page
          </Typography>
          <FormControlLabel
            sx={{ mt: 1, mb: 1, ml: 0 }}
            control={
              <Checkbox
                checked={termsChecked}
                onChange={() => setTermsChecked(t => !t)}
                name="terms"
                required
              />
            }
            label={
              <span>
                I agree to the&nbsp;
                <a href={termsOfUse} target="_blank" rel="noopener noreferrer">
                  Terms of Use
                </a>
              </span>
            }
          />

          <LoadingButton
            loading={loading}
            type="submit"
            variant="contained"
            sx={{
              width: '100%', height: '42px', boxShadow: 'none',
              fontSize: '16px', fontWeight: '400', mt: 1, mb: 6,
              bgcolor: 'primary.main', color: 'white', border: 'none',
            }}
            disabled={!termsChecked}
          >
            Submit
          </LoadingButton>
        </form>
      </Box>
    </>
      :
      <Box sx={{
        display: 'flex', flexDirection: 'column', alignItems: 'center',
        mt: 3, mb: 7, width: '90%',
      }}>
        <LoadingButton
          loading={loading}
          variant='contained'
          sx={{
            width: '100%',
          }}
          onClick={() => {
            if (typeof pin === 'string') {
              onSubmit(pin)
            }
          }}
        >
          {text}
        </LoadingButton>

        {isAuthenticated &&
          <Button
            component={NavLink}
            to="/closings"
            sx={{
              width: '100%',
              mt: 1,
            }}
          >
            View your {ClosingsText}
          </Button>}
      </Box>
  )
}
